import { useState, useEffect } from 'react'
import MainTitle from '../../components/MainTitle'
import { PhoneNumberUtil } from 'google-libphonenumber'
// import { usePlacesWidget } from "react-google-autocomplete"
import AutoComplete from 'react-google-autocomplete'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import useAuth from '../../hooks/useAuth'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import { Switch } from '@headlessui/react'

const GOOGLE_API_KEY = 'AIzaSyDcTd3xEx_Y4ZlRo-7eeoSWzLUnWO67LFU'

function CreateSchool() {

  const axios = useAxiosPrivate()
  const { setShowLoader, createInfo } = useAuth()

  const navigate = useNavigate()

  const [validEmail, setValidEmail] = useState(true)
  const [validPhoneNumber, setValidPhoneNumber] = useState(true)
  const [schoolData] = useState({})
  const [schoolAddress, setSchoolAddress] = useState({})
  const [regions, setRegions] = useState([])

  const [contactMethods, setContactMethods] = useState([])
  const [allowedContactTypes] = useState([])
  const [phoneNumber, setPhoneNumber] = useState('')
  const [isValid, setIsValid] = useState(false)
  const [enabled, setEnabled] = useState(true)

  const [submitting, setSubmitting] = useState(false)

  const handlePhoneNumberChange = (event) => {
    const { value } = event.target
    setPhoneNumber(value)
    const isValidNumber = validatePhoneNumber(value)
    setIsValid(isValidNumber)
  }

  const validatePhoneNumber = (phoneNumber) => {
    const phoneNumberUtil = PhoneNumberUtil.getInstance()

    try {
      const parsedNumber = phoneNumberUtil.parse(phoneNumber, '+44')
      const isValidNumber = phoneNumberUtil.isValidNumber(parsedNumber)
      return isValidNumber
    } catch (e) {
      console.error('Error parsing phone number:', e)
      return false
    }
  }

  const updateContactMethod = (method) => {
    let index = allowedContactTypes.indexOf(method.id)
    if (index === -1) {
      allowedContactTypes.push(method.id)
    } else {
      allowedContactTypes.splice(index, 1)
    }
  }

  const getRegions = async () => {
    try {
      const response = await axios.get(`/regions/all`)
      setRegions(response.data.result)
    } catch (error) {}
  }

  const createSchool = async (e) => {
    e.preventDefault()
    // setValidEmail(true)
    // setValidPhoneNumber(true)
    // setShowLoader(true)

    setSubmitting(true)
    setShowLoader(true)

    //check urn
    if (schoolData.urn?.length !== 6) {
      createInfo('error', 'Please enter a 6 digit URN')
      setSubmitting(false)
      return
    }

    //validate inputs
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){1,}$/
    const emailValid = emailRegex.test(schoolData.email)
    if (!emailValid) {
      createInfo('error', `Please enter a valid email address`)
      setSubmitting(false)
      return
    }

    //Check user email
    try {
      const response = await axios.get(`/client/by-email/${schoolData.email}`)
      if (response.data.error === true) {
        setShowLoader(false)
        setValidEmail(false)
        createInfo('error', `This email is already in use ${schoolData.email}`)
        setSubmitting(false)
        return
      }
    } catch (error) {}
    //check user phone number
    try {
      const response = await axios.get(
        `/client/by-number/${schoolData.phone_number}`
      )
      if (response.data.error === true) {
        setShowLoader(false)
        setValidPhoneNumber(false)
        createInfo('error', `This mobile number is already in use`)
        setSubmitting(false)
        return
      }
    } catch (error) {} finally{
      setShowLoader(false)
    }

    const data = {
      school: {
        name: schoolData.name,
        email: schoolData.email,
        status_id: 1,
        school:1,
        child:0
      },
      school_details: {
        school_address: schoolData.address,
        phone_number: schoolData.phone_number.replace(/\s/g, ''),
        region_id: schoolData.region,
        school_contact_name: schoolData.contact_name,
        contact_time: schoolData.contact_time,
        send_notifications: enabled,
        school_urn: schoolData.urn,
      },
      contact_methods: allowedContactTypes,
    }

    try {
      const response = await axios.post('/schools/create', data)
      setShowLoader(false)
      if (response.data.error === false) {
        createInfo('success', `Created School: ${schoolData.name}`)
        navigate(`/schools`)
        setSubmitting(false)
      }
    } catch (error) {
      setShowLoader(false)
    }
  }

  const updateSchoolAddress = (address) => {
    let addressString = ''

    Object.keys(address).forEach((key, index) => {
      if (key === 'value') {
        return
      }

      if (!address[key] || address[key].trim() === '') {
        return
      }

      addressString += address[key]

      if (index !== Object.keys(address).length - 1) {
        addressString += ', '
      }
    })

    schoolData.address = addressString
  }

  const getContactMethods = async () => {
    try {
      const response = await axios.get(`/contact-methods/all`)
      setContactMethods(response.data.result)
    } catch (error) {}
  }

  useEffect(() => {
    getContactMethods()
    setPhoneNumber('+44')
    getRegions()
  }, [])

  return (
    <section>
      <MainTitle title="Create School" backButton />
      <section>
        <form className="w-full relative" onSubmit={createSchool}>
          <div className="mt-6">
            <div>
              <h3 className="text-md font-bold mb-2">School Info</h3>
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="School_urn"
                    className="block text-xs font-medium text-gray-700"
                  >
                    School URN
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={schoolData.urn}
                      type="number"
                      name="School_urn"
                      required
                      id="School_urn"
                      onChange={(e) => (schoolData.urn = e.target.value)}
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md [&::-webkit-inner-spin-button]:appearance-none"
                    />
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="School_name"
                    className="block text-xs font-medium text-gray-700"
                  >
                    School Name
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={schoolData.name}
                      type="text"
                      name="School_name"
                      required
                      id="School_name"
                      onChange={(e) => (schoolData.name = e.target.value)}
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                  </div>
                </div>
                <div className="mb-3 w-1/2 ml-2">
                  <label
                    htmlFor="School_email"
                    className="block text-xs font-medium text-gray-700"
                  >
                    School Email
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={schoolData.email}
                      type="School_email"
                      required
                      name="email"
                      id="School_email"
                      onChange={(e) => (schoolData.email = e.target.value)}
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                    <p
                      id="emailnote"
                      className={
                        !validEmail ? 'instructions failed' : 'offscreen'
                      }
                    >
                      <FontAwesomeIcon icon={faCircleExclamation} />
                      This email already exists, please enter a different one.
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="client_region"
                    className="block text-xs font-medium text-gray-700"
                  >
                    School Region
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <select
                      className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
                      required
                      onChange={(e) => (schoolData.region = e.target.value)}
                    >
                      <option disabled value>
                        Select Region
                      </option>
                      {regions?.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.title}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                </div>
              </div> 
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="school_address"
                    className="block text-xs font-medium text-gray-700"
                  >
                    Address
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <AutoComplete
                      defaultValue={schoolData.address}
                      type="text"
                      name="school_address"
                      required
                      id="school_address"
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                      apiKey={GOOGLE_API_KEY}
                      onPlaceSelected={(place) => {
                        const addressFormatted = place.formatted_address
                        const segments = place.address_components
                        let data = {}
                        segments.forEach((key) => {
                          const type = key.types[0]
                          data[type] = key.long_name
                        })

                        const formattedSegments = addressFormatted.split(', ')

                        const address = {
                          address_line_1: data['street_number']
                            ? data['street_number'] + ' ' + data['route']
                            : formattedSegments[1],
                          address_line_2:
                            data['locality'] ?? data['political'],
                          city: data['postal_town'],
                          county: data['administrative_area_level_2'],
                          country: data['country'],
                          postcode: data['postal_code'],
                        }

                        setSchoolAddress(address)
                        updateSchoolAddress(address)
                      }}
                      options={{
                        types: [],
                        componentRestrictions: { country: 'gb' },
                      }}
                    />
                  </div>
                </div>
              </div>
              {schoolAddress.address_line_1 && (
                <>
                  <div className="flex">
                    <div className="mb-3 w-1/2 mr-2">
                      <label
                        htmlFor="school_address_line_1"
                        className="block text-xs font-medium text-gray-700"
                      >
                        Address Line 1
                      </label>
                      <div className="mt-1 relative rounded-md">
                        <input
                          value={schoolAddress.address_line_1 || ''}
                          type="text"
                          name="school_address_line_1"
                          required
                          id="school_address_line_1"
                          onChange={(e) => {
                            const address = schoolAddress
                            address.address_line_1 = e.target.value
                            setSchoolAddress({
                              ...schoolAddress,
                              address_line_1: e.target.value,
                            })
                            updateSchoolAddress(address)
                          }}
                          className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                        />
                      </div>
                    </div>
                    <div className="mb-3 w-1/2 ml-2">
                      <label
                        htmlFor="school_address_line_2"
                        className="block text-xs font-medium text-gray-700"
                      >
                        Address Line 2 (Optional)
                      </label>
                      <div className="mt-1 relative rounded-md">
                        <input
                          value={schoolAddress.address_line_2 || ''}
                          type="text"
                          name="school_address_line_2"
                          id="school_address_line_2"
                          onChange={(e) => {
                            const address = schoolAddress
                            address.address_line_2 = e.target.value
                            setSchoolAddress({
                              ...schoolAddress,
                              address_line_2: e.target.value,
                            })
                            updateSchoolAddress(address)
                          }}
                          className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="mb-3 w-1/2 mr-2">
                      <label
                        htmlFor="school_city"
                        className="block text-xs font-medium text-gray-700"
                      >
                        City
                      </label>
                      <div className="mt-1 relative rounded-md">
                        <input
                          value={schoolAddress.city || ''}
                          type="text"
                          name="school_city"
                          required
                          id="school_city"
                          onChange={(e) => {
                            const address = schoolAddress
                            address.city = e.target.value
                            setSchoolAddress({
                              ...schoolAddress,
                              city: e.target.value,
                            })
                            updateSchoolAddress(address)
                          }}
                          className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                        />
                      </div>
                    </div>
                    <div className="mb-3 w-1/2 ml-2">
                      <label
                        htmlFor="school_county"
                        className="block text-xs font-medium text-gray-700"
                      >
                        County
                      </label>
                      <div className="mt-1 relative rounded-md">
                        <input
                          value={schoolAddress.county || ''}
                          type="text"
                          name="school_county"
                          required
                          id="school_county"
                          onChange={(e) => {
                            const address = schoolAddress
                            address.county = e.target.value
                            setSchoolAddress({
                              ...schoolAddress,
                              county: e.target.value,
                            })
                            updateSchoolAddress(address)
                          }}
                          className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="mb-3 w-1/2 mr-2">
                      <label
                        htmlFor="school_postcode"
                        className="block text-xs font-medium text-gray-700"
                      >
                        Postcode
                      </label>
                      <div className="mt-1 relative rounded-md">
                        <input
                          value={schoolAddress.postcode || ''}
                          type="text"
                          name="school_postcode"
                          required
                          id="school_postcode"
                          onChange={(e) => {
                            const address = schoolAddress
                            address.postcode = e.target.value
                            setSchoolAddress({
                              ...schoolAddress,
                              postcode: e.target.value,
                            })
                            updateSchoolAddress(address)
                          }}
                          className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                        />
                      </div>
                    </div>
                    <div className="mb-3 w-1/2 ml-2">
                      <label
                        htmlFor="school_country"
                        className="block text-xs font-medium text-gray-700"
                      >
                        Country
                      </label>
                      <div className="mt-1 relative rounded-md">
                        <input
                          value={schoolAddress.country || ''}
                          type="text"
                          name="school_country"
                          required
                          id="school_country"
                          onChange={(e) => {
                            const address = schoolAddress
                            address.country = e.target.value
                            setSchoolAddress({
                              ...schoolAddress,
                              country: e.target.value,
                            })
                            updateSchoolAddress(address)
                          }}
                          className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="flex">
                <div className="w-1/2 ml-2"></div>
              </div>
            </div>
            <hr className="bg-gray-300 w-full my-4" />
            <div>
              <h3 className="text-md font-bold mb-2">Contact Details</h3>
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="School_name"
                    className="block text-xs font-medium text-gray-700"
                  >
                    Contact Name
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={schoolData.school_contact_name}
                      type="text"
                      name="School_contact_name"
                      required
                      id="School_contact_name"
                      onChange={(e) => (schoolData.contact_name = e.target.value)}
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                  </div>
                </div>
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="School_number"
                    className="block text-xs font-medium text-gray-700"
                  >
                    Contact Number{' '}
                    <span className="text-blue-500 text-xs">
                      (Please use +44 and no spaces)
                    </span>
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={schoolData.phone_number}
                      type="text"
                      required
                      minLength="3"
                      name="School_number"
                      id="School_number"
                      value={phoneNumber}
                      onChange={(e) => {
                        handlePhoneNumberChange(e)
                        schoolData.phone_number = e.target.value
                      }}
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                    {phoneNumber.length > 3 && (
                      <>
                        {isValid ? (
                          <span className="text-green-500 text-sm">
                            Valid phone number
                          </span>
                        ) : (
                          <span className="text-red-600 text-sm">
                            Invalid phone number
                          </span>
                        )}
                      </>
                    )}
                    <p
                      id="emailnote"
                      className={
                        !validPhoneNumber
                          ? 'instructions failed'
                          : 'offscreen'
                      }
                    >
                      <FontAwesomeIcon icon={faCircleExclamation} />
                      This Phone number already exists, please enter a
                      different one.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <hr className="bg-gray-300 w-full my-4" />
            <div>
              <h3 className="text-md font-bold mb-2">Contact Preferences</h3>
              <div className="flex items-center justify-between space-x-6">
                <div className="mb-3 w-1/2">
                  <label
                    htmlFor="contact_time"
                    className="block text-xs font-medium text-gray-700"
                  >
                    Preferred Contact Time
                  </label>
                  <div className="mt-1 relative rounded-md mr-2">
                    <input
                      defaultValue={schoolData.contact_time}
                      type="text"
                      name="contact_time"
                      id="contact_time"
                      onChange={(e) =>
                        (schoolData.contact_time = e.target.value)
                      }
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                  </div>
                </div>
                <div className="mb-3 w-1/2">
                  <div className="font-medium text-gray-700 text-xs mr-2 min-w-[200px] mb-2">
                    Send automatic notifications?
                  </div>
                  <div className="flex items-center">
                    <span className="pr-2 text-gray-700 text-sm">No</span>
                    <Switch
                      checked={enabled}
                      onChange={setEnabled}
                      className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 data-[checked]:bg-blue-500"
                    >
                      <span className="sr-only">Use setting</span>
                      <span className="pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5">
                        <span
                          aria-hidden="true"
                          className="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity duration-200 ease-in group-data-[checked]:opacity-0 group-data-[checked]:duration-100 group-data-[checked]:ease-out"
                        >
                          <svg
                            fill="none"
                            viewBox="0 0 12 12"
                            className="h-3 w-3 text-gray-400"
                          >
                            <path
                              d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <span
                          aria-hidden="true"
                          className="absolute inset-0 flex h-full w-full items-center justify-center opacity-0 transition-opacity duration-100 ease-out group-data-[checked]:opacity-100 group-data-[checked]:duration-200 group-data-[checked]:ease-in"
                        >
                          <svg
                            fill="currentColor"
                            viewBox="0 0 12 12"
                            className="h-3 w-3 text-indigo-600"
                          >
                            <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                          </svg>
                        </span>
                      </span>
                    </Switch>
                    <span className="pl-2 text-gray-700 text-sm">Yes</span>
                  </div>
                </div>
              </div>
              <div className="mt-4">
                <label
                  htmlFor="contact_time"
                  className="block text-xs font-medium text-gray-700 flex-col pb-2"
                >
                  Allowed Contact Methods
                </label>
                <div className="mb-3 w-1/2 mr-2 flex">
                  {contactMethods?.map((method) => {
                    return (
                      <div className="items-center flex">
                        <input
                          type="checkbox"
                          id="contact_method"
                          value={method.title}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                          onChange={() => updateContactMethod(method)}
                        />
                        <label
                          htmlFor="clinic_details"
                          className="ml-2 mr-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          {method.title}
                        </label>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            <hr className="bg-gray-300 w-full my-4" />
            <div className="flex mt-2">
              <button
                type="submit"
                className={` ${!isValid ? 'btn disabled' : 'btn'}`}
                disabled={!isValid || submitting}
              >
                Create School
              </button>
            </div>
          </div>
        </form>        
      </section>
    </section>
  )
}

export default CreateSchool